import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-packages-new-support',
  templateUrl: './icon-packages-new-support.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPackagesNewSupportComponent {}
